import { getCurrentInstance, ref } from '@vue/composition-api';
export function useMQHook(){
  const MQLoading = ref(false);
  const timer = ref(null);
  const vm = getCurrentInstance()?.proxy;
  function rollCheckMQ(){
    MQLoading.value = true;
    return new Promise((resolve, reject) => {
      clearInterval(timer.value);
      const startTime = +new Date();
      timer.value = setInterval(()=> {
        const container = document.querySelector('#meiqia-container');
        const error = container?.querySelector('#networkErr');
        // eslint-disable-next-line
        const hasChat = document.querySelector('iframe[name="chat"]')?.contentDocument?.querySelector('[data-cy="send-btn"]')
        if (error) {
          vm.openFeedBack?.();
          clearInterval(timer.value);
          MQLoading.value = false;
          reject();
          return;
        }
        if (hasChat) {
          clearInterval(timer.value);
          MQLoading.value = false;
          resolve();
          return;
        }
        if (+new Date() - startTime > 6000) {
          setTimeout(() => {
            vm.$message.info('在线客服唤起异常，您可以联系我们的钉钉客服或企业微信客服');
          }, 500);
          
          vm.openFeedBack?.();    
          clearInterval(timer.value);
          MQLoading.value = false;
          reject();
        }
      }, 100);
    });
  }
  return {
    rollCheckMQ,
    MQLoading,
    timer
  };
}